import { CrudBase } from "../../crud";
import { BasicCrud } from "../../../utils/interfaces/crud/imp/crud-basic";

class _DataProviderController extends CrudBase {
    employees = [];
    filters = [];

    constructor() {
        super({
            name: "data-provider",
            modules: {
                crud: new BasicCrud()
            },
            useHeadersAndFormLayout: false
        });
    }

    onReady() {
        this.actions = this.repo.data_provider;
    }

    async getFilters() {
        var response = await this.execute(this.actions.getFilters);

        this.filters = response.data;
    }

    async findUser(query) {
        var response = await this.execute(this.actions.findUser, null, `?query=${query}`);

        var employeeIds = this.employees.map(e => e.id);

        response.forEach(element => {
            if (!employeeIds.includes(element.id)) {
                this.employees.push(element);
            }
        });
    }
}

export const DataProviderController = new _DataProviderController();